<section>
  <form class="searchbar" role="search">
    <input
      name="search"
      #searchInput
      [(ngModel)]="query"
      (keyup.enter)="onEnter()"
      type="search"
      placeholder="Search"
      spellcheck="false" />
    <button type="submit" aria-label="Otsi" (click)="onEnter()">
      <svg viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="7"></circle>
        <path d="M20 20L16.5 16.5"></path>
      </svg>
    </button>
  </form>

  <div *ngIf="youtube.loading()"><loading></loading></div>
  @if (hasSearched() === false && hardcodedResults === true) {
    <div id="disclamer">Hardcoded otsingutulemused</div>
    @for (result of dummyResults(); track result.youtubeId) {
      <youtube-thumbnail
        (click)="addToPlaylist(result)"
        [video]="result"></youtube-thumbnail>
    }
  } @else {
    @for (result of results(); track result.youtubeId) {
      <youtube-thumbnail
        (click)="addToPlaylist(result)"
        [video]="result"></youtube-thumbnail>
    }
  }
</section>
<navigator />
